module.exports = __webpack_public_path__ + "media/images/admin-427c5071087d9e04a4e45b303e55b741.png";